import {css} from "styled-components";

/**
 * Layout primitives shared by every page.
 */

export const BREAKPOINTS = {
    xs: 420,
    sm: 620,
    md: 860,
    lg: 1080,
    xl: 1320
}

type BreakpointKey = keyof typeof BREAKPOINTS

export const down = (key: BreakpointKey) => `@media (max-width: ${BREAKPOINTS[key]}px)`

export const up = (key: BreakpointKey) => `@media (min-width: ${BREAKPOINTS[key] + 1}px)`

export const CONTENT_MAX_WIDTH = 1320

/** Centered page gutter — used by every section that is not full bleed. */
export const container = css`
    width: 100%;
    max-width: ${CONTENT_MAX_WIDTH}px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 clamp(18px, 4vw, 48px);
`

/** Frosted panel used by the header, drawers and floating bars. */
export const glass = css`
    background-color: rgba(10, 10, 13, 0.72);
    backdrop-filter: saturate(160%) blur(18px);
    -webkit-backdrop-filter: saturate(160%) blur(18px);
`

/** Small all-caps label, the typographic signature of the redesign. */
export const eyebrow = css`
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: ${({theme}) => theme.colorMuted};
`

/** Big editorial heading with a fluid size. */
export const displayHeading = css`
    font-family: ${({theme}) => theme.font.display};
    font-weight: 700;
    letter-spacing: -0.035em;
    line-height: 0.98;
    color: ${({theme}) => theme.color};
    margin: 0;
`

/** Keyboard focus ring, applied consistently to every interactive element. */
export const focusRing = css`
    &:focus-visible {
        outline: 2px solid ${({theme}) => theme.accent};
        outline-offset: 3px;
    }
`

export const hideScrollbar = css`
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
`
